import type { FC } from 'react';

import { getCtaButtonHrefWithSessionId } from '@/modules/promo';

import { ScLogo, type ScLogoProps } from './styled';

interface LogoProps extends ScLogoProps {
  logoSrc?: string;
  href?: string;
  afterRegistrationRedirect?: string;
}

export const Logo: FC<LogoProps> = ({
  logoSrc,
  logoSize,
  href,
  afterRegistrationRedirect,
}) => (
  <ScLogo
    href={href ?? getCtaButtonHrefWithSessionId(afterRegistrationRedirect)}
    logoSize={logoSize}
  >
    <img alt="Logo" src={logoSrc || '/images/logo.svg?url'} />
  </ScLogo>
);
